import Chip from '@mui/material/Chip';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import {packId} from 'common/diplomatIdUtil';
import React from 'react';
import {Link} from 'react-router-dom';
import DiplomatStateStatusIcon from 'components/icons/DiplomatStateStatusIcon';

type ReferenceItemsProps = {
   name?: string;
   data: {id: string; name: string; objectType?: string; folderId: string}[];
   noData?: string;
};

const useStyles = makeStyles((theme) => ({
   root: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      '& > *': {
         margin: theme.spacing(0.5),
      },
   },
   label: {
      display: 'flex',
      alignItems: 'center',
   },
}));

const ReferenceItems = ({name, data, noData}: ReferenceItemsProps) => {
   const classes = useStyles();
   const isEmpty = data.length === 0;
   return (
      <div className={classes.root}>
         {name && <Typography variant={'body2'}>{name}:</Typography>}
         {isEmpty ? (
            <Typography variant={'body2'}>
               <i>{noData}</i>
            </Typography>
         ) : (
            data.map((data) => (
               <Chip
                  key={data.id}
                  label={
                     <>
                        <DiplomatStateStatusIcon name={data.name} folderId={data.folderId} />
                        {data.name}
                     </>
                  }
                  classes={{
                     label: classes.label,
                  }}
                  component={Link}
                  to={`/${packId(data.objectType, data.id)}`}
                  clickable
               />
            ))
         )}
      </div>
   );
};

export default ReferenceItems;
